<template>
  <v-col :cols="cols">
    <line-chart :chart-data="datacollection" :height="height" :style="style" :options="options"></line-chart>
  </v-col>
</template>

<script>
import LineChart from "./LineChart.js";
import { colors } from "./color-sets.js";
const AVERAGE_LABEL = '(平均値: ';
export default {
  components: {
    LineChart
  },
  data() {
    return {
      options: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const targetData = data.datasets[tooltipItem.datasetIndex];
              let label = targetData.label.split(AVERAGE_LABEL)[0].trim();
              label += ": " + tooltipItem.value;
              return label;
            }
          }
        }
      }
    };
  },
  computed: {
    datacollection() {
      return this.lineChartDataCollection(
        this.dimensions,
        this.aggregatedValues
      );
    }
  },
  props: ["height", "style", "cols", "dimensions", "aggregatedValues"],
  methods: {
    lineChartDataCollection(dimensions, aggregatedValues) {
      let labels = [];
      let datasets = [];
      if (dimensions.length == undefined || dimensions.length == 0) {
        return {
          labels: [],
          datasets: []
        };
      }
      labels = aggregatedValues[dimensions[0]]
        .sort((a, b) => a.id - b.id)
        .map(item => {
          return item.name;
        });
      dimensions.map((dimension, index) => {
        let values = [];
        let color = colors[index % colors.length];
        aggregatedValues[dimension]
          .sort((a, b) => a.id - b.id)
          .map(item => {
            values.push(parseFloat(item.value));
          });
        const total = values.reduce((a, b) => a + b, 0);
        const average = (total / values.length).toFixed(2);
        datasets.push({
          label: `${dimension} ${AVERAGE_LABEL} ${average})`,
          fill: false,
          borderColor: color,
          lineTension: 0,
          borderWidth: 2,
          data: values
        });
      });
      return {
        labels: labels,
        datasets: datasets
      };
    }
  }
};
</script>